import { Injectable } from '@angular/core';
import { VGenBirimService } from '../ctl-vgen-birim.service';
import { DataCoreService } from '../../../../services/data-core.service';
@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private service: VGenBirimService) {}

    getData(control: any, selectedBirimTuru: string) {
        let tableName = control.dlistMetadata.baseEntity
    if(this.service.isYetkili){
        tableName = tableName + "?BirimTuru=YS"
      }
      else{
        tableName = tableName + "?BirimTuru=" + selectedBirimTuru;
      }
            const dataSource = this.dataCoreService.getOData(tableName);
            dataSource.select([]);
            const filterArr = [];
            filterArr.push(['AktifEh', '=', 'E']);
            if(filterArr.length > 0) dataSource.filter(filterArr)
            dataSource.sort([{ selector: 'Kod', desc: true }]);
            return dataSource;
    }

    getCheckData(code: number) {
        const dataSource = this.dataCoreService.getOData('IkaBirimKatsayi');
        dataSource.select(['Kod','AktifEh','BirimTuru']);
        const filterArr = [];
        filterArr.push(['Kod', '=', code]);
        if (filterArr.length > 0) dataSource.filter(filterArr);
        return dataSource;
}

}
